module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/pic_blockchain.054b20ca-2326f20c04ed0bee90e8009b2af205cb.png";